import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/ui/Sidebar/Sidebar";
import { useAuth } from '../context/AuthContext';

const PrivateRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    const ignoringPathPatterns = [/\/translations$/, /^\/login\/[a-f\d]{8}-([a-f\d]{4}-){3}[a-f\d]{12}$/, /^\/email-login\/[a-f\d]{8}-([a-f\d]{4}-){3}[a-f\d]{12}$/, /\/recent-translations$/, /\/preview-doc\/[a-f\d]{8}-([a-f\d]{4}-){3}[a-f\d]{12}$/];
    const ignoreSidebar = ignoringPathPatterns.some(pattern => pattern.test(location.pathname));

    if (isLoading) return null;

    return isAuthenticated ? (
        <div className={`main-container ${!ignoreSidebar ? "d-flex" : ""}`}>
            {!ignoreSidebar && <Sidebar />}
            <div className="outlet-container">
                <Outlet />
            </div>
        </div>
    ) : (
        <Navigate to="/" />
    );
};

export default PrivateRoute;
